export default __webpack_public_path__ + "static/media/IMG_0424 copie.150586bc.jpg";